import React from 'react';
import styled from 'styled-components';

import ActualizationDate from '../../containers/navigation/ActualizationDate';
import ProjectSelect from '../../containers/navigation/ProjectSelect';

const StyledExecuteOptions = styled.div`
  flex-grow: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;
const SimpleNavigationBar = ({ children }) => (
  <div className="navigation-bar">
    <ProjectSelect />
    <div>
      <ActualizationDate />
    </div>
    <StyledExecuteOptions>{children}</StyledExecuteOptions>
  </div>
);

export default SimpleNavigationBar;
